import script from "./HrViolationActionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./HrViolationActionDetail.vue?vue&type=script&setup=true&lang=js"

import "./HrViolationActionDetail.vue?vue&type=style&index=0&id=1d928e2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d928e2a"]])

export default __exports__